export const LOADING = "LOADING";
export const LOADED = "LOADED";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const SETLAYOUT = "SETLAYOUT";
export const SETKEY = "SETKEY";
